import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Component/pages/Home.js";
import Panel1 from "./Component/pages/Panel1.jsx";
import JodiPanel from "./Component/pages/JodiPanel.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/panel/:panelAlias" element={<Panel1 />} />
        <Route path="/jodi/:JodiAlias" element={<JodiPanel />} />
      </Routes>

    </>
  );
}
export default App;
